/**
 * Avance del D-Talk por área — mismo formato que el del Mapa de Talento
 * (feedback 30/09: "que se vea el % completado en cada área"): barra
 * horizontal por área con "% · completadas/convocadas" al costado; el desglose
 * en curso / sin iniciar queda en el tooltip.
 * Recibe filas que pasan TODOS los filtros MENOS el de área: el propósito es
 * el resumen comparativo de todas las áreas (con el filtro de área aplicado
 * colapsaría a una sola barra), pero sí respeta país / líder / level / etc.
 */
import { Card, CardContent } from '@/components/ui/card';
import { AreaProgressChart } from '@/components/performance/AreaProgressChart';
import { buildDTalkAreaProgress, type DTalkStatsRow } from '@/../../shared/dtalk-stats';
import { useTranslation } from 'react-i18next';

export function DTalkAreaProgressChart({ rows }: { rows: DTalkStatsRow[] }) {
  const { t } = useTranslation();
  const areas = buildDTalkAreaProgress(rows);
  if (areas.length === 0) return null;

  const done = areas.reduce((n, a) => n + a.completadas, 0);
  const total = areas.reduce((n, a) => n + a.convocadas, 0);
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <Card>
      <CardContent className="p-5">
        <h3 className="font-semibold mb-1">{t('performance.dtalkareaprogresschart.avance_por_area')}</h3>
        <p className="text-xs text-muted-foreground mb-3">
          {t('performance.dtalkareaprogresschart.subtitle', { done, total, pct })}
        </p>
        <AreaProgressChart
          rows={areas.map(a => ({ ...a, pct: a.pctCompletadas, done: a.completadas, total: a.convocadas }))}
          tooltip={a => [
            t('performance.dtalkareaprogresschart.tooltip', {
              done: a.completadas, inProgress: a.enCurso, notStarted: a.noIniciadas,
            }),
            `${a.convocadas} ${t('performance.dtalkareaprogresschart.convocadas')}`,
          ]}
        />
      </CardContent>
    </Card>
  );
}
